import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const PROPERTY_FAQ_AB_TEST_ID = "rp_faq_property_page";

/** No FAQ section at all — the base version of the property page */
export const PROPERTY_FAQ_NOT_LOGIN_BASE_VARIANT = "faq_not_login_base" as const;
/** No FAQ section at all — the base version of the property page */
export const PROPERTY_FAQ_LOGIN_BASE_VARIANT = "faq_login_base" as const;
/** Anonymous users see the FAQ with answers available without signing in */
export const PROPERTY_FAQ_NOT_LOGIN_OPEN_VARIANT = "faq_not_login_open" as const;
/** Signed-in users see the FAQ with answers available right away */
export const PROPERTY_FAQ_LOGIN_OPEN_VARIANT = "faq_login_open" as const;
/** Anonymous users see the FAQ with answers behind the registration gate */
export const PROPERTY_FAQ_NOT_LOGIN_GATED_VARIANT = "faq_not_login_gated" as const;

/**
 * A single A/B test managed by Amplitude Experiment for both signed-in and anonymous users — the auth-state split
 * is handled by Amplitude targeting, encoded in the variant names. The FAQ renders only for the `open`/`gated`
 * variants; the `base` variants (and any unassigned state) keep the section hidden. With `withSSR: true` the variant
 * is resolved on the server and becomes part of the page cache key, so property pages are cached per variant.
 * The FAQ section itself still mounts after hydration — `usePropertyFaqExperiment` reads the test client side,
 * so SSR emits just the section anchor.
 * The Amplitude flag must expose the variants listed below.
 * Override in dev: ?ab_test_experiment=rp_faq_property_page&ab_test_variant=faq_login_open
 */
export const propertyFaqAbTest: IABTestConfiguration = {
    id: PROPERTY_FAQ_AB_TEST_ID,
    name: OngoingABTests.PROPERTY_FAQ,
    expires: new Date(2027, 0, 1),
    path: [rpAppPath.property.detail.base],
    variants: [
        PROPERTY_FAQ_NOT_LOGIN_BASE_VARIANT,
        PROPERTY_FAQ_LOGIN_BASE_VARIANT,
        PROPERTY_FAQ_NOT_LOGIN_OPEN_VARIANT,
        PROPERTY_FAQ_LOGIN_OPEN_VARIANT,
        PROPERTY_FAQ_NOT_LOGIN_GATED_VARIANT
    ],
    withSSR: true,
    useAmplitude: true
};
import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const PROPERTY_FAQ_AB_TEST_ID = "rp_faq_property_page";

/** No FAQ section at all — the base version of the property page */
export const PROPERTY_FAQ_NOT_LOGIN_BASE_VARIANT = "faq_not_login_base" as const;
/** No FAQ section at all — the base version of the property page */
export const PROPERTY_FAQ_LOGIN_BASE_VARIANT = "faq_login_base" as const;
/** Anonymous users see the FAQ with answers available without signing in */
export const PROPERTY_FAQ_NOT_LOGIN_OPEN_VARIANT = "faq_not_login_open" as const;
/** Signed-in users see the FAQ with answers available right away */
export const PROPERTY_FAQ_LOGIN_OPEN_VARIANT = "faq_login_open" as const;
/** Anonymous users see the FAQ with answers behind the registration gate */
export const PROPERTY_FAQ_NOT_LOGIN_GATED_VARIANT = "faq_not_login_gated" as const;

/**
 * A single A/B test managed by Amplitude Experiment for both signed-in and anonymous users — the auth-state split
 * is handled by Amplitude targeting, encoded in the variant names. The FAQ renders only for the `open`/`gated`
 * variants; the `base` variants (and any unassigned state) keep the section hidden. With `withSSR: true` the variant
 * is resolved on the server and becomes part of the page cache key, so property pages are cached per variant.
 * The FAQ section itself still mounts after hydration — `usePropertyFaqExperiment` reads the test client side,
 * so SSR emits just the section anchor.
 * The Amplitude flag must expose the variants listed below.
 * Override in dev: ?ab_test_experiment=rp_faq_property_page&ab_test_variant=faq_login_open
 */
export const propertyFaqAbTest: IABTestConfiguration = {
    id: PROPERTY_FAQ_AB_TEST_ID,
    name: OngoingABTests.PROPERTY_FAQ,
    expires: new Date(2027, 0, 1),
    path: [rpAppPath.property.detail.base],
    variants: [
        PROPERTY_FAQ_NOT_LOGIN_BASE_VARIANT,
        PROPERTY_FAQ_LOGIN_BASE_VARIANT,
        PROPERTY_FAQ_NOT_LOGIN_OPEN_VARIANT,
        PROPERTY_FAQ_LOGIN_OPEN_VARIANT,
        PROPERTY_FAQ_NOT_LOGIN_GATED_VARIANT
    ],
    withSSR: true,
    useAmplitude: true
};
